var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8339 9.79121C10.6755 9.79121 10.5172 9.73288 10.3922 9.60788C10.1505 9.36621 10.1505 8.96621 10.3922 8.72454L17.2255 1.89121C17.4672 1.64954 17.8672 1.64954 18.1089 1.89121C18.3505 2.13288 18.3505 2.53288 18.1089 2.77454L11.2755 9.60788C11.1505 9.73288 10.9922 9.79121 10.8339 9.79121Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.334 6.29199C17.9923 6.29199 17.709 6.00866 17.709 5.66699V2.29199H14.334C13.9923 2.29199 13.709 2.00866 13.709 1.66699C13.709 1.32533 13.9923 1.04199 14.334 1.04199H18.334C18.6757 1.04199 18.959 1.32533 18.959 1.66699V5.66699C18.959 6.00866 18.6757 6.29199 18.334 6.29199Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4993 18.9587H7.49935C2.97435 18.9587 1.04102 17.0253 1.04102 12.5003V7.50033C1.04102 2.97533 2.97435 1.04199 7.49935 1.04199H9.16602C9.50768 1.04199 9.79102 1.32533 9.79102 1.66699C9.79102 2.00866 9.50768 2.29199 9.16602 2.29199H7.49935C3.65768 2.29199 2.29102 3.65866 2.29102 7.50033V12.5003C2.29102 16.342 3.65768 17.7087 7.49935 17.7087H12.4993C16.341 17.7087 17.7077 16.342 17.7077 12.5003V10.8337C17.7077 10.492 17.991 10.2087 18.3327 10.2087C18.6744 10.2087 18.9577 10.492 18.9577 10.8337V12.5003C18.9577 17.0253 17.0243 18.9587 12.4993 18.9587Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.204d02519567d8a85ad9bb413b4903bd.svg";
export { ForwardRef as ReactComponent };